import { Link } from "@tanstack/react-router";
import { type ReactNode } from "react";
import { AppShell } from "./AppShell";
import { SiteFooter } from "./SiteFooter";

/**
 * Shared shell for the public policy pages. These render outside the wallet
 * gate so they stay readable before a vault exists.
 */
export function LegalPage({
  eyebrow,
  title,
  updated,
  intro,
  children,
}: {
  eyebrow: string;
  title: string;
  updated: string;
  intro: string;
  children: ReactNode;
}) {
  return (
    <AppShell>
      <div className="animate-rise space-y-4 pb-4">
        <section className="panel p-5">
          <p className="label-instrument">{eyebrow}</p>
          <h1 className="mt-2 text-[22px] font-medium leading-tight tracking-tight">{title}</h1>
          <p className="readout mt-2 text-[10px] uppercase tracking-[0.15em] text-faint">
            Last updated {updated}
          </p>
          <p className="readout mt-3 text-[11px] leading-relaxed text-muted">{intro}</p>
        </section>

        <div className="space-y-4">{children}</div>

        <Link
          to="/"
          className="readout flex h-11 w-full items-center justify-center rounded-lg border border-border text-[10px] uppercase tracking-[0.15em] text-muted transition-colors hover:text-accent"
        >
          Back to wallet
        </Link>

        <SiteFooter />
      </div>
    </AppShell>
  );
}

export function LegalSection({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <section className="panel space-y-2 p-4">
      <h2 className="text-[14px] font-semibold tracking-tight">{heading}</h2>
      <div className="readout space-y-2 text-[11px] leading-relaxed text-muted">{children}</div>
    </section>
  );
}
